import {
    ENTRYVERSION_LIST_REQUESTED,
    ENTRYVERSION_LIST_RECEIVED,
    ENTRYVERSION_LIST_ERROR
} from '../actions/entryVersionList.js';
import RequestState from "../storage/RequestState";
import RequestResult from "../storage/RequestResult";
import {EMPTY_REQUEST_RESULT_INIT_STATE} from "../utils/JsObjectHelper";

/**
 *
 * @param {RequestResult} state
 * @param {BaseAction|ReceiveEntryTypesAction|ReceiveErrorAction} action
 * @return {RequestResult}
 */
export const entryVersionList = (state = EMPTY_REQUEST_RESULT_INIT_STATE, action)  => {

    switch (action.type) {
        case ENTRYVERSION_LIST_REQUESTED:
            return new RequestResult(RequestState.getInstanceLoading(), state.data);
        case ENTRYVERSION_LIST_RECEIVED:
            return new RequestResult(RequestState.getInstanceDone(), action.entryVersionList, action.receivedAt);
        case ENTRYVERSION_LIST_ERROR:
            return new RequestResult(
                RequestState.getInstanceError(
                    action.errorResponseStatusCode,
                    action.errorResponseMessage ? action.errorResponseMessage : null
                ),
                state.getData()
            );
        default:
            return state
    }
};
